// extracted by mini-css-extract-plugin
export default {"addToCart":"AddedToCart_addToCart__FyliW","add":"AddedToCart_add__jo4+q"};